import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import classes from "./LoginZipGame.module.css";
import Header from '../../components/Header';
import ZipGameStepperLogin from '../../components/ZipGameStepperLogin';
import { useNavigate } from 'react-router-dom';
import { loginZipUser } from '../../http/http';
import { useDispatch } from 'react-redux';
import { setUserZip } from '../../store/slices/userZipGameTokenSlice';
import { toast } from 'react-toastify';
import { FaArrowLeft } from 'react-icons/fa6';

const LoginZipGame = () => {
    const { t } = useTranslation();
    const [msisdn, setMsisdn] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleNext = async () => {
        if (!msisdn.trim()) return;

        try {
            // hit here the api for user login

            const response = await loginZipUser(msisdn);
            console.log(response?.data?.result, 'response-');

            if (response?.data?.result?.loginStatus == 1) {


                // user is login success
                navigate("/login/verify-otp/zip-game", {
                    state: { msisdn },
                });
            }
            else {
                // you are not registered!
                toast.error(t("188"));
            }


        } catch (error) {
            console.log(error, 'error-');
            toast.error(error?.response?.data?.message || t("189"));
        }

    };

    return (
        <>
            <Header />

            <div className={classes.container}>

                <div className={classes.header_section}>
                    <div className={classes.back_button} onClick={() => {
                        navigate("/");
                    }}>
                        <FaArrowLeft className={classes.back_icon} />
                    </div>
                </div>


                <div className={classes.heroCard}>
                    <div className={classes.heroBadge}>{t("173")}</div>
                    <h1 className={classes.heroTitle}>{t("184")}</h1>
                    <p className={classes.heroText}>
                        {t("185")}
                    </p>
                </div>

                <ZipGameStepperLogin currentStep={1} />

                <div className={classes.formCard}>
                    <div className={classes.section}>
                        <div className={classes.sectionHead}>
                            <h2 className={classes.sectionTitle}>{t("176")}</h2>
                            <p className={classes.sectionText}>
                                {t("177")}
                            </p>
                        </div>

                        <div className={classes.inputGroup}>
                            <label className={classes.label} htmlFor="msisdn">
                                {t("178")}
                            </label>

                            <div className={classes.phoneField}>
                                <div className={classes.countryBox}>
                                    <img
                                        src="/assets/images/madagascar.png"
                                        alt="flag"
                                        className={classes.flag}
                                    />
                                    <span className={classes.code}>+245</span>
                                </div>

                                <input
                                    id="msisdn"
                                    type="number"
                                    className={classes.input}
                                    placeholder={t("179")}
                                    value={msisdn}
                                    onChange={(e) => setMsisdn(e.target.value)}
                                    onWheel={(e) => e.target.blur()}
                                />
                            </div>
                        </div>

                        <div className={classes.infoBox}>
                            <p>
                                {t("180")}
                            </p>
                        </div>

                        <button type="button" className={classes.primaryBtn} onClick={() => handleNext()}>
                            {t("181")}
                        </button>

                        {/* here it will be the register option */}
                        <p className={classes.link_text}>
                            {t("186")}<span onClick={() => navigate("/register/zip-game")}>{t("187")}</span>
                        </p>

                    </div>
                </div>
            </div>
        </>
    )
}

export default LoginZipGame